var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('div',{staticClass:"info"},[_vm._v(" "+_vm._s(_vm.$t('notallowed.info'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }